import { Table } from "antd";

const SelectedVehicleTable = (props) => {
  const { tableDataSource, tableColumns, pagination, className } = props;

  return (
    <>
      <Table
        className={className}
        dataSource={tableDataSource || []}
        columns={tableColumns}
        pagination={pagination || false}
      />
    </>
  );
};
export default SelectedVehicleTable;
